export default "__VITE_ASSET__BBUBw4Wm__"